import { ButtonColor } from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/Button';
import { CheckBox } from '@lmt/unicorn-shared/app/components/common/ui-kit/CheckBox';
import { useModal } from '@lmt/unicorn-shared/app/components/common/ui-kit/modal/useModal';
import { GenerateDataOptions } from '@lmt/unicorn-shared/app/helpers/generateTestData';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React, { useCallback } from 'react';
import styles from '@lmt/unicorn-shared/src/app/components/common/Dialog/Dialog.module.scss';

export function useGenerateDataDialog() {
  const modal = useModal();
  const i18n = useScopedTranslation('tenant_settings.general_settings');

  return useCallback(async () => {
    const result = await showGenerateDataDialog();
    if (result) {
      import('@lmt/unicorn-shared/app/helpers/generateTestData').then(
        (generateTestData) => {
          generateTestData.generateTestData(result);
        },
      );
    }
  }, []);

  function showGenerateDataDialog() {
    return modal.showCustom<GenerateDataOptions>({
      title: i18n.t('generate_test_data.confirmation_title'),
      defaultValue: {
        generateAdditionalSubtenants: false,
      },
      Component: (props) => {
        return (
          <>
            <span className={styles.text}>
              {i18n.t('generate_test_data.confirmation_text')}
            </span>
            <CheckBox
              className={styles.options}
              title={i18n.t(
                'generate_test_data.generate_additional_subtenants',
              )}
              checked={props.value?.generateAdditionalSubtenants}
              onChange={(e) =>
                props.setValue({
                  generateAdditionalSubtenants: e.currentTarget.checked,
                })
              }
            />
          </>
        );
      },
      okButtonText: i18n.t('generate_test_data.confirmation_button'),
      okButtonColor: ButtonColor.Danger,
    });
  }
}
